// extracted by mini-css-extract-plugin
module.exports = {"capacityInput":"reservedCapacity_capacityInput__3AnKF","periodCol":"reservedCapacity_periodCol__Eq4lj","typeCol":"reservedCapacity_typeCol__1P7Zx"};